var render = function render(){
  var _vm$establishment_sav, _vm$establishment_sav2, _vm$establishment_sav3, _vm$establishment_sav4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "content"
  }, [_c('h6', {
    staticClass: "stitch-modal__title"
  }, [_vm._v("Information")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('Field', {
    attrs: {
      "error-messages": (_vm$establishment_sav = _vm.establishment_saving_errors) === null || _vm$establishment_sav === void 0 ? void 0 : _vm$establishment_sav.name,
      "label": _vm.$translate('labels.name'),
      "name": "name",
      "autofocus": "",
      "required": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.establishment.name,
      callback: function callback($$v) {
        _vm.$set(_vm.establishment, "name", $$v);
      },
      expression: "establishment.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('Field', {
    attrs: {
      "error-messages": (_vm$establishment_sav2 = _vm.establishment_saving_errors) === null || _vm$establishment_sav2 === void 0 ? void 0 : _vm$establishment_sav2.code,
      "label": _vm.$translate('labels.code_automatically_generated'),
      "name": "code",
      "required": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.establishment.code,
      callback: function callback($$v) {
        _vm.$set(_vm.establishment, "code", $$v);
      },
      expression: "establishment.code"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.billing_accounts,
      "label": _vm.$translate('labels.billingAccount'),
      "error-messages": (_vm$establishment_sav3 = _vm.establishment_saving_errors) === null || _vm$establishment_sav3 === void 0 ? void 0 : _vm$establishment_sav3.billingaccount,
      "item-text": "name",
      "item-value": "id",
      "clearable": true,
      "outlined": "",
      "dense": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.establishment.billingaccount,
      callback: function callback($$v) {
        _vm.$set(_vm.establishment, "billingaccount", $$v);
      },
      expression: "establishment.billingaccount"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": _vm.$translate('labels.mainEstablishment'),
      "hide-details": ""
    },
    model: {
      value: _vm.establishment.main,
      callback: function callback($$v) {
        _vm.$set(_vm.establishment, "main", $$v);
      },
      expression: "establishment.main"
    }
  }), _c('p', {
    staticClass: "text-caption text--secondary mb-0 mt-2"
  }, [_vm._v(" " + _vm._s(_vm.$translate("mainEstablishmentExplanation")) + " ")])], 1)], 1), _c('AddressForm', {
    staticClass: "mt-0",
    attrs: {
      "title": _vm.$translate('labels.address'),
      "errors": (_vm$establishment_sav4 = _vm.establishment_saving_errors) === null || _vm$establishment_sav4 === void 0 ? void 0 : _vm$establishment_sav4.address
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.establishment.address,
      callback: function callback($$v) {
        _vm.$set(_vm.establishment, "address", $$v);
      },
      expression: "establishment.address"
    }
  })], 1), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('buttons.cancel'),
      "ghost": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.save_text
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }